module.exports = __webpack_public_path__ + "static/group-93x-33cb08fdf42f69ef1365bc95fc555703.png";